export interface ResumeLocation {
	city?: string;
	region?: string;
	country?: string;
}
export interface ResumeWorkExperience {
	jobTitle: string;
	employer: string;
	location?: ResumeLocation;
	startDate?: string;
	endDate?: string;
	current?: boolean;
	highlights?: string;
	relevantSkills?: string;
}
export interface ResumeEducation {
	schoolName: string;
	location?: ResumeLocation;
	educationLevel?: string;
	fieldOfStudy?: string;
	graduation?: string;
	details?: string;
}
export interface ResumeReference {
	name: string;
	designation?: string;
	workPlace?: string;
	location?: ResumeLocation;
	phone?: string;
	email?: string;
}
export interface TailoredResume {
	contact: {
		firstName: string;
		middleName?: string;
		lastName: string;
		title?: string;
		email?: string;
		phone?: string;
		location?: ResumeLocation;
	};
	summary?: string;
	skills?: string;
	workExperience?: ResumeWorkExperience[];
	education?: ResumeEducation[];
	certifications?: string;
	languages?: Array<{ language: string; proficiency?: string }>;
	accomplishments?: string;
	affiliations?: string;
	personalLinks?: Array<{ type?: string; value: string }>;
	references?: ResumeReference[];
	additionalInfo?: string;
	customSections?: Array<{ title: string; content: string }>;
}

export function escapeHtml(text: unknown): string {
	return String(text).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
}

export function renderInline(text: unknown): string {
	return escapeHtml(text)
		.replace(/\*\*(.+?)\*\*/g, "<strong>$1</strong>")
		.replace(/\b_(.+?)_\b/g, "<em>$1</em>");
}

export function mdToHtml(markdown?: string): string {
	if (!markdown) return "";
	const blocks = String(markdown)
		.trim()
		.split(/\n{2,}/);
	return blocks
		.map((block) => {
			const rows = block.split("\n");
			let html = "";
			let inList = false;
			for (const row of rows) {
				const bullet = row.match(/^\s*[-*]\s+(.*)$/);
				if (bullet) {
					if (!inList) {
						html += "<ul>";
						inList = true;
					}
					html += "<li>" + renderInline(bullet[1]) + "</li>";
				} else if (row.trim() !== "") {
					if (inList) {
						html += "</ul>";
						inList = false;
					}
					html += "<p>" + renderInline(row.trim()) + "</p>";
				}
			}
			if (inList) html += "</ul>";
			return html;
		})
		.join("");
}

export function locationText(location?: ResumeLocation): string {
	if (!location) return "";
	return [location.city, location.region, location.country].filter(Boolean).join(", ");
}

export function dateRange(item: Pick<ResumeWorkExperience, "startDate" | "endDate" | "current">): string {
	const start = item.startDate || "";
	const end = item.current ? "Present" : item.endDate || "";
	if (start && end) return start + " – " + end;
	return start || end || "";
}

export function fullName(contact: TailoredResume["contact"]): string {
	return [contact.firstName, contact.middleName, contact.lastName].filter(Boolean).join(" ");
}
